var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 272",
    style: {
      enableBackground: "new 0 0 288 272"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "cross-sign_1_",
    transform: "translate(1069 297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    className: "st0",
    d: "M-866.5-213.9l-8.3-8.8c-2.1-2.3-5.7-2.4-8-0.3c-0.1,0.1-0.2,0.2-0.3,0.3l-41.5,44.4 l-42.3-45.2c-2.1-2.3-5.7-2.4-8-0.3c-0.1,0.1-0.2,0.2-0.3,0.3l-8.3,8.9c-2.3,2.5-2.3,6.4,0,8.9l42.2,45.1l-41.3,44.5 c-2.3,2.5-2.3,6.4,0,8.9l8.3,8.9c2.1,2.3,5.7,2.4,8,0.3c0.1-0.1,0.2-0.2,0.3-0.3l41.4-44.4l41.5,44.4c2.1,2.3,5.7,2.4,8,0.3 c0.1-0.1,0.2-0.2,0.3-0.3l8.3-8.9c2.3-2.5,2.3-6.4,0-8.9l-41.7-44.4l41.5-44.4C-864.2-207.5-864.2-211.4-866.5-213.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,266c-71.7,0-130-58.3-130-130S72.3,6,144,6c71.7,0,130,58.3,130,130S215.7,266,144,266z M144,23 C81.7,23,31,73.7,31,136s50.7,113,113,113s113-50.7,113-113S206.3,23,144,23z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.f51f7486.svg";
export { ForwardRef as ReactComponent };